import { ROW_HEIGHT } from "./dateUtils";

export const calculateRowHeights = (flatResources: any[], events: any[], positionedEvents: Map<string, any> ) => {
  return flatResources.map((resource) => {
    if (resource.type === 'add_button') {
      return ROW_HEIGHT;
    }

    if (resource.type === 'project' || resource.type === 'team') {
      return ROW_HEIGHT;
    }

    if (resource.type === 'person' || resource.type === 'teamProject') {
      const resourceEvents = events.filter(e => {
        const isIdMatch = e.resourceId === resource.id;
        
        if (isIdMatch && resource.type === 'person') {
          return e.types === 'task' && e.ProjectId == resource.ProjectId;
        }
        
        if (isIdMatch && resource.type === 'teamProject') {
          return e.types === 'taskTeam' && e.parentResourceId === resource.parentId;
        }
        
        return false;
      });

      if (resourceEvents.length === 0) {
        return ROW_HEIGHT;
      }

      let maxLanes = 1;
      resourceEvents.forEach(event => {
        if (event.types === 'task' || event.types === 'taskTeam') {
          const positioned = positionedEvents.get(event.id);
          if (positioned && positioned.totalLanes > maxLanes) {
            maxLanes = positioned.totalLanes;
          }
        }
      });

      const EVENT_HEIGHT = 37;
      const EVENT_GAP = 2;
      const PADDING = 10;
      const BOTTOM_SPACING = 45;
      const calculatedHeight = 
        (EVENT_HEIGHT * maxLanes) + 
        (EVENT_GAP * (maxLanes - 1)) + 
        PADDING + 
        BOTTOM_SPACING;

      return calculatedHeight;
    }

    return ROW_HEIGHT;
  });
};